export default __webpack_public_path__ + "static/media/terms-conditions.ffa4d286.svg";